import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'time-categories-settings',
} as const satisfies Location
